import { IMAGE_HOST } from 'src/utils/constants';

export const CellContent = (props: any) => {
  const { icon, hasIcon, children } = props;

  const isSvgIcon = icon && icon.icon.indexOf("<svg xmlns") === 0;

  // sajnos a pdf kezelő nem egységesen kezeli ezért muszáj külön választani a designt
  const isSvgFromUrl =
    icon && icon.icon.substr(icon.icon.length - 4) === ".svg";

  const isProtocolInUrl = (icon: any) => {
    return typeof icon === "string" && icon.indexOf("http") === 0;
  };

  return (
    <>
      {hasIcon && icon && isSvgIcon && (
        <div
          style={{ height: "25px", width: "25px", marginRight: "15px" }}
          dangerouslySetInnerHTML={{ __html: icon.icon }}
        />
      )}
      {hasIcon && icon && isSvgFromUrl && (
        <div
        style = {{
          height: "25px",
          minHeight: "25px",
          maxHeight: "25px",
          width: "25px",
          minWidth: "25px",
          maxWidth: "25px",
          marginRight: "15px",
          display: "inline-block",
        }}>
          <img
            src={
              isProtocolInUrl(icon.icon) ? icon.icon : `${IMAGE_HOST}${icon.icon}`
            }
            style={{
              height: "100%",
              width: "100%",
              aspectRatio : "1",
            }}
          />
        </div>
      )}
      {hasIcon && icon && !isSvgIcon && !isSvgFromUrl && (
        <img
          src={
            isProtocolInUrl(icon.icon) ? icon.icon : `${IMAGE_HOST}${icon.icon}`
          }
          height="25"
          width="25"
          style={{ marginRight: "15px" }}
        />
      )}

      {children}
    </>
  );
};
